import { render, staticRenderFns } from "./OfferDetailsComponent.vue?vue&type=template&id=74820050&scoped=true"
import script from "./OfferDetailsComponent.vue?vue&type=script&lang=js"
export * from "./OfferDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./OfferDetailsComponent.vue?vue&type=style&index=0&id=74820050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74820050",
  null
  
)

export default component.exports